module.exports = __webpack_public_path__ + "static/media/frank.bdcd3c9b.jpeg";